import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SocketProvider } from "./context/SocketContext";
import { Toaster } from "sonner";
import Header from "./components/Header";
import AIAssistant from "./components/AIAssistant";
import Landing from "./pages/Landing";
import { LoginPage, RegisterPage } from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Subjects from "./pages/Subjects";
import SubjectDetail from "./pages/SubjectDetail";
import Profile from "./pages/Profile";
import People from "./pages/People";
import { DonatePage, DonateSuccess, DonateCancel } from "./pages/Donate";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="p-10 text-center text-[color:var(--bee-muted)]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function Shell() {
  const [aiOpen, setAiOpen] = useState(false);
  const [aiSubject, setAiSubject] = useState(null);
  const openAI = (subject) => { setAiSubject(subject || null); setAiOpen(true); };

  return (
    <>
      <Header onOpenAI={() => openAI()} />
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><RegisterPage /></PublicOnly>} />
          <Route path="/dashboard" element={<Protected><Dashboard onOpenAI={() => openAI()} /></Protected>} />
          <Route path="/subjects" element={<Protected><Subjects /></Protected>} />
          <Route path="/subjects/:slug" element={<Protected><SubjectDetail onOpenAI={openAI} /></Protected>} />
          <Route path="/people" element={<Protected><People /></Protected>} />
          <Route path="/profile" element={<Protected><Profile /></Protected>} />
          <Route path="/u/:userId" element={<Protected><Profile /></Protected>} />
          <Route path="/donate" element={<Protected><DonatePage /></Protected>} />
          <Route path="/donate/success" element={<Protected><DonateSuccess /></Protected>} />
          <Route path="/donate/cancel" element={<Protected><DonateCancel /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <AIAssistant open={aiOpen} onClose={() => setAiOpen(false)} subject={aiSubject} />
      <Toaster richColors position="top-right" />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <SocketProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </SocketProvider>
    </AuthProvider>
  );
}
